// Sentence case with known acronyms upper-cased ("ICHRA affordability").
const ACRONYMS = ['ichra', 'mcp']

export const featureLabel = (key: string) => {
  const words = key.split('_').map((w) => (ACRONYMS.includes(w) ? w.toUpperCase() : w))
  const [first = '', ...rest] = words
  return [first.charAt(0).toUpperCase() + first.slice(1), ...rest].join(' ')
}
